export const matchKeys = {
  all: ['match'] as const,
  questions: (species: 'Cat' | 'Dog') =>
    [...matchKeys.all, 'questions', species] as const,
};
